export default "__VITE_ASSET__XUO5XqeV__"